
<template>
  <div class="limitBox">
    <Timeline v-if="dataList.length>0">
      <Timeline-item v-for="(item,index) in dataList"
                     :key="index">
        <span class="icon_end"
              v-show="item.stateText == '已还清'"></span>
        <div class="box"
             :class="{'color33':item.stateText!='已还清'}">
          <p class="time">{{item.periods}}</p>
          <p class="content">还款金额{{ item.rpyMoney}} <span class="stateText"
                  :class="{'clear_color':item.stateText=='已还款'}">{{item.stateText}}</span> </p>
          <p class="content">应还日期{{ item.dueDate}}</p>
          <p class="content"
             v-show="item.stateText == '已还清'">还款日期{{ item.rpyDate}}</p>
        </div>
      </Timeline-item>
    </Timeline>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      dataList: [
        {
          periods: '第1期',
          rpyMoney: '￥1033.33',
          stateText: '待还清',
          dueDate: '2023.03.15',
        },
        {
          periods: '第2期',
          rpyMoney: '￥1033.33',
          stateText: '待还清',
          dueDate: '2023.04.15',
        },
        {
          periods: '第3期',
          rpyMoney: '￥1033.34',
          stateText: '待还清',
          dueDate: '2023.05.15',
        },
      ],
      page: '',
    }
  },
  mounted () {
    this.page = this.$route.query.page;
    this.util.title('分期账单');
    if (this.page == 1) {
      this.dataList = [
        {
          periods: '第1期',
          rpyMoney: '￥1030.00',
          stateText: '已还款',
          dueDate: '2023.02.20',
        },
        {
          periods: '第2期',
          rpyMoney: '￥1030.00',
          stateText: '待还清',
          dueDate: '2023.03.20',
        },
        {
          periods: '第3期',
          rpyMoney: '￥1030.00',
          stateText: '待还清',
          dueDate: '2023.04.20',
        },
      ]
    } else if (this.page == 2) {
      this.dataList = [
        {
          periods: '第1期',
          rpyMoney: '￥1733.33',
          stateText: '待还清',
          dueDate: '2023.03.21',
        },
        {
          periods: '第2期',
          rpyMoney: '￥1733.33',
          stateText: '待还清',
          dueDate: '2023.04.21',
        },
        {
          periods: '第3期',
          rpyMoney: '￥1733.34',
          stateText: '待还清',
          dueDate: '2023.05.21',
        },
      ]
    } else if (this.page == 3) {
      this.dataList = [
        {
          periods: '第1期',
          rpyMoney: '￥1550.00',
          stateText: '待还清',
          dueDate: '2023.03.10',
        },
        {
          periods: '第2期',
          rpyMoney: '￥1550.00',
          stateText: '待还清',
          dueDate: '2023.04.10',
        },
        {
          periods: '第3期',
          rpyMoney: '￥1550.00',
          stateText: '待还清',
          dueDate: '2023.05.10',
        },
        {
          periods: '第4期',
          rpyMoney: '￥1550.00',
          stateText: '待还清',
          dueDate: '2023.06.10',
        },
        {
          periods: '第5期',
          rpyMoney: '￥1550.00',
          stateText: '待还清',
          dueDate: '2023.07.10',
        },
        {
          periods: '第6期',
          rpyMoney: '￥1550.00',
          stateText: '待还清',
          dueDate: '2023.08.10',
        },
      ]
    }
  },
  methods: {
    //去借款
    toLoan (item) {
      window.location.href = item.pageUrl;
    },

  }

}
</script>
<style>
.limitBox .ivu-timeline-item-tail {
  border-left: 1px solid #ededed;
}
</style>
<style scoped>
.limitBox {
  background: #fff;
  padding: 0.15rem;
  font-size: 0.13rem;
  color: #929196;
}
.time {
  margin-bottom: 0.17rem;
}
.content {
  padding-left: 5px;
  margin-bottom: 0.13rem;
}
.stateText {
  float: right;
}
.clear_color {
  color: #999999;
}
.color33 {
  color: #333;
}
.icon {
  background: url('../../assets/img/afterLoan/add_btn.png') no-repeat top center;
  width: 0.16rem;
  height: 0.16rem;
  background-size: 100% 100%;
}
.icon_end {
  display: inline-block;
  background: url('../../assets/img/afterLoan/icon_end.png') no-repeat top
    center;
  width: 0.15rem;
  height: 0.15rem;
  background-size: 100% 100%;
  z-index: 111;
  position: absolute;
  left: -0.01rem;
  top: 0.02rem;
}
.noData {
  text-align: center;
  padding-top: 0.5rem;
  font-size: 0.16rem;
}
</style>
